
export const colorScheme = {
    light: {
        root: {
            colorOne: '{primary.500}',
            colorTwo: '{secondary.500}',
            colorThree: '{primary.300}',
            colorFour: '{secondary.300}'
        }
    },
    dark: {
        root: {
            colorOne: '{primary.400}',
            colorTwo: '{secondary.400}',
            colorThree: '{primary.600}',
            colorFour: '{secondary.600}'
        }
    }
};

export default {
    colorScheme
};
